/* eslint-disable tailwindcss/no-arbitrary-value --
   `text-[--text-secondary]` reaches the token's #424242; `text-text/secondary`
   is shadowed by the legacy palette (fe-services CLAUDE.md > Design tokens). */

/**
 * Full-width band labelling one reward source in the reward modal, in every
 * mode (CMS-1687, restyled by CMS-1922).
 */
export const SectionLabel = ({ children }: { children: string }) => (
  <div className="flex w-full items-center gap-spacing/gap/soft-4px rounded-radius/button bg-fill/alternative-1 px-spacing/padding/soft-8px py-spacing/padding/soft-4px">
    <span className="mhg-alpha-typography-bullet-2 text-[--text-secondary]">
      {children}
    </span>
  </div>
);
